/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_UnlimitedInputs */

const en_dialog_premium_unlimited = /** @type {(inputs: Dialog_Premium_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload unlimited papers with Listening Premium`)
};

const es_dialog_premium_unlimited = /** @type {(inputs: Dialog_Premium_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube documentos ilimitados con Listening Premium`)
};

/**
* | output |
* | --- |
* | "Upload unlimited papers with Listening Premium" |
*
* @param {Dialog_Premium_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_unlimited = /** @type {((inputs?: Dialog_Premium_UnlimitedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_UnlimitedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_unlimited(inputs)
	return en_dialog_premium_unlimited(inputs)
});